var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('amapLocation',{model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}},[_c('div',{staticStyle:{"background-color":"#FFFFFF","height":"100px","border-radius":"5px"}},[_vm._v(_vm._s(_vm.location.address || ''))])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5729c4a6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/test.vue
// module id = A5j2
// module chunks = 0